import { Form, Formik } from 'formik';
import React, { FC } from 'react';
import AnimateHeight from 'react-animate-height';
import * as Yup from 'yup';
import { ReactComponent as IconCar } from '../../icons/car.svg';
import { ReactComponent as IconHouse } from '../../icons/house.svg';
import { ReactComponent as IconMailOpen } from '../../icons/mail-open.svg';
import Button from '../base/button';
import FormikCheckbox from '../base/forms/formikCheckbox';
import FormikCheckboxTile from '../base/forms/formikCheckboxTile/formikCheckboxTile';
import FormikCheckboxTileGroup from '../base/forms/formikCheckboxTile/formikCheckboxTileGroup';
import FormikFieldWrapper from '../base/forms/formikFieldWrapper';
import { StyledFormikErrorMessage } from '../base/forms/formikFieldWrapper.styles';
import FormikNumberInput from '../base/forms/formikNumberInput';
import FormikRadio from '../base/forms/formikRadio';
import FormikRadioTile from '../base/forms/formikRadioTile/formikRadioTile';
import FormikRadioWrapper from '../base/forms/formikRadioWrapper';
import { StyledFormikField } from '../base/forms/input';
import { Label } from '../base/forms/label';
import { Column } from '../base/grid';
import { H1 } from '../base/typography';
import * as StyledFormikTest from './formikTest.styles';

const initialValues = {
	firstName: '',
	lastName: '',
	email: '',
	payer: '',
	serviceType: '',
	serviceTypePostbox: '',
	packageType: '',
	packageTypePackageCount: 1,
	extraServices: [],
	postkrafaAmount: '',
	postkrafaId: '',
	postkrafaBank: '',
	postkrafaHb: '',
	postkrafaRkn: '',
	postkrafaTilvisun: '',
	senderForeignCitizenship: false,
};

const SignupSchema = Yup.object().shape({
	firstName: Yup.string().min(2, 'Too Short!').max(50, 'Too Long!').required('First name required'),
	lastName: Yup.string().min(2, 'Too Short!').max(50, 'Too Long!').required('Last Name required'),
	email: Yup.string().email('Invalid email').required('Email required'),
	options: Yup.object().required('You must choose an option'),
	countries: Yup.string().required('You must choose a country'),
	payer: Yup.string().required('You must choose one'),
	serviceType: Yup.string().required('You must choose a service'),
	serviceTypePostbox: Yup.string(),
	packageType: Yup.string().required('You must choose a shipment type'),
	packageTypePackageCount: Yup.number(),
	extraServices: Yup.array(),
	postkrafaAmount: Yup.string().when('extraServices', {
		is: val => {
			return val.includes('postkrafa');
		},
		then: Yup.string().required('Skylda er að slá inn magn'),
	}),
	postkrafaId: Yup.string(),
	postkrafaBank: Yup.string(),
	postkrafaHb: Yup.string(),
	postkrafaRkn: Yup.string(),
	postkrafaTilvisun: Yup.string(),
	senderForeignCitizenship: Yup.bool(),
});

interface Props {}
/*
const options = [
	{ label: 'Food', value: '1' },
	{ label: 'Being Fabulous', value: '2' },
	{ label: 'Ken Wheeler', value: '3' },
	{ label: 'ReasonML', value: '4' },
	{ label: 'Unicorns', value: '5' },
	{ label: 'Kittens', value: '6' },
];

const postboxOptions = [
	{ label: '101 Reykjavík', value: '101 Reykjavik' },
	{ label: '102 Reykjavík', value: '102 Reykjavik' },
	{ label: '103 Reykjavík', value: '103 Reykjavik' },
	{ label: '104 Reykjavík', value: '104 Reykjavik' },
];

const setFlag = (flag = '#ccc') => ({
	alignItems: 'center',
	display: 'flex',

	':before': {
		backgroundImage: `url(https://postur.is/images/flags-small/${flag.toLowerCase()}.png)`,
		backgroundSize: 'contain',
		backgroundPosition: '50% 50%',
		backgroundRepeat: 'no-repeat',
		content: '" "',
		display: 'block',
		marginRight: 20,
		height: 35,
		width: 35,
	},
});

const countriesSelectStyles = produce(selectStyles, draftState => {
	// @ts-ignore
	draftState.singleValue = (styles, { data }) => ({
		...styles,
		...setFlag(data.value),
	});
	// @ts-ignore
	draftState.option = (styles, { data }) => ({
		...styles,
		...setFlag(data.value),
	});
}); */

const FormikTest: FC<Props> = () => {
	return (
		<StyledFormikTest.Wrapper>
			<H1 marginBottom="3rem">Formik test</H1>
			<Formik initialValues={initialValues} validationSchema={SignupSchema} onSubmit={() => {}}>
				{({ values, setFieldValue, setFieldTouched }) => (
					<Form>
						<StyledFormikTest.FieldWrapper>
							<Column tablet={1 / 2}>
								<Label htmlFor="firstName">Settu inn fornafn hér</Label>
								<StyledFormikField
									type="text"
									id="firstName"
									name="firstName"
									placeholder="Fornafn.."
								/>
								<StyledFormikErrorMessage name="firstName" component="div" />
							</Column>
							<Column tablet={1 / 2}>
								<Label htmlFor="lastName">Settu inn eftirnafn hér</Label>
								<StyledFormikField
									type="text"
									id="lastName"
									name="lastName"
									placeholder="Eftirnafn.."
								/>
								<StyledFormikErrorMessage name="lastName" component="div" />
							</Column>
						</StyledFormikTest.FieldWrapper>
						<StyledFormikTest.FieldWrapper>
							<Column tablet={1 / 2}>
								<FormikFieldWrapper
									label="Settu inn netfang hér"
									name="email"
									languageComponent="registerShipment">
									<StyledFormikField type="text" id="email" name="email" placeholder="Netfang.." />
								</FormikFieldWrapper>
							</Column>
							<Column tablet={1 / 2}>
								<FormikFieldWrapper
									label="Veldu úr listanum"
									name="options"
									languageComponent="registerShipment">
									{/* <FormikSelect
										id="options"
										name="options"
										value={values.options}
										options={options}
										onBlur={setFieldTouched}
										onChange={setFieldValue}
									/> */}
								</FormikFieldWrapper>
							</Column>
						</StyledFormikTest.FieldWrapper>
						<StyledFormikTest.FieldWrapper>
							<Column tablet={1 / 2}>
								<FormikFieldWrapper
									label="Veldu land"
									name="countries"
									languageComponent="registerShipment">
									{/* <FormikSelect
										id="countries"
										name="countries"
										value={values.countries}
										options={countries.is}
										onBlur={setFieldTouched}
										styles={countriesSelectStyles}
										onChange={setFieldValue}
									/> */}
								</FormikFieldWrapper>
							</Column>
						</StyledFormikTest.FieldWrapper>
						<StyledFormikTest.FieldWrapper>
							<Column>
								<FormikFieldWrapper
									label="Hver greiðir?"
									name="payer"
									languageComponent="registerShipment">
									<FormikRadioWrapper>
										<FormikRadio
											id="sendandi"
											name="payer"
											label="Sendandi"
											setFieldValue={setFieldValue}
										/>
										<FormikRadio
											id="vidtakandi"
											name="payer"
											label="Viðtakandi (verð 300 kr.)"
											setFieldValue={setFieldValue}
										/>
									</FormikRadioWrapper>
								</FormikFieldWrapper>
							</Column>
						</StyledFormikTest.FieldWrapper>
						<StyledFormikTest.FieldWrapper>
							<Column>
								<FormikFieldWrapper
									label="Veldu þjónustu"
									name="serviceType"
									languageComponent="registerShipment">
									<FormikRadioTile
										active
										id="heimAdDyrum"
										name="serviceType"
										setFieldValue={setFieldValue}
										icon={IconCar}
										price="1.269"
										label="Pakki sendur heim að dyrum"
									/>
									<FormikRadioTile
										active
										id="naestaPostuhus"
										setFieldValue={setFieldValue}
										name="serviceType"
										icon={IconHouse}
										price="910"
										label="Pakki á næsta pósthús"
									/>
									<FormikRadioTile
										active
										id="postbox"
										setFieldValue={setFieldValue}
										name="serviceType"
										icon={IconMailOpen}
										price="845"
										label="Pakki í póstbox">
										<AnimateHeight
											height={values.serviceType === 'postbox' ? 'auto' : 0}
											duration={400}>
											<div style={{ margin: '3rem 0' }}>
												Póstbox eru opin allan sólarhringinn, alla daga ársins og eru því kjörin
												fyrir þá sem vilja sveigjanlegan afgreiðslutíma. Póstboxin eru átta
												talsins á höfuðborgarsvæðinu, hólfin eru í þremur mismunandi stærðum og
												pakkar geta verið allt að 20 kg.
											</div>
											{/* <FormikSelect
												id="serviceTypePostbox"
												name="serviceTypePostbox"
												value={values.serviceTypePostbox}
												options={postboxOptions}
												onBlur={setFieldTouched}
												placeholder="Veldu póstbox"
												onChange={setFieldValue}
											/> */}
										</AnimateHeight>
									</FormikRadioTile>
								</FormikFieldWrapper>
							</Column>
						</StyledFormikTest.FieldWrapper>
						<StyledFormikTest.FieldWrapper>
							<Column>
								<FormikFieldWrapper
									label="Hvað ertu að senda?"
									name="packageType"
									languageComponent="registerShipment">
									<FormikRadioTile
										active
										id="letter"
										name="packageType"
										icon={IconMailOpen}
										setFieldValue={setFieldValue}
										label="Rekjanlegt bréf"
									/>
									<FormikRadioTile
										setFieldValue={setFieldValue}
										active
										id="package"
										name="packageType"
										icon={IconHouse}
										label="Pakki"
										renderTopRight={() => (
											<FormikNumberInput
												id="packageTypePackageCount"
												name="packageTypePackageCount"
												onChange={setFieldValue}
												value={values.packageTypePackageCount}
												label="Veldu fjölda pakka"
											/>
										)}
									/>
								</FormikFieldWrapper>
							</Column>
						</StyledFormikTest.FieldWrapper>
						<StyledFormikTest.FieldWrapper>
							<Column>
								<FormikFieldWrapper
									label="Veldu viðbótarþjónustu"
									name="extraServices"
									languageComponent="registerShipment">
									<FormikCheckboxTileGroup
										id="extraServices"
										onBlur={setFieldTouched}
										onChange={setFieldValue}
										value={values.extraServices}>
										<FormikCheckboxTile
											values={[]}
											setFieldValue={setFieldValue}
											active
											id="fragile"
											icon={IconCar}
											label="Brothætt"
											name="fragile"
											price="500">
											<div style={{ margin: '3rem 0' }}>
												Mikilvægt er að velja þessa þjónustu fyrir pakka sem eru viðkvæmir og
												hljóta þá sérstaka meðhöndlun. Velja þarf umbúðir í samræmi við
												innihald.
											</div>
										</FormikCheckboxTile>
										<FormikCheckboxTile
											values={[]}
											setFieldValue={setFieldValue}
											active
											id="postkrafa"
											icon={IconMailOpen}
											label="Brothætt"
											name="Póstkrafa"
											price="500">
											<div style={{ margin: '3rem 0' }}>
												Póstkröfuþóknun er 2,5% af upphæð. Lágmarksgjald er 750 kr. sem
												jafngildir póstkröfu að verðmæti 30.000 kr. Póstkröfur eru greiddar inn
												á bankareikning sendanda innan þriggja virkra daga frá innlausn
												póstkröfu.
											</div>
											<Label>Upplýsingar</Label>
											<StyledFormikTest.FieldWrapper>
												<Column tablet={1 / 2}>
													<FormikFieldWrapper
														name="postkrafaAmount"
														languageComponent="registerShipment">
														<StyledFormikField
															type="text"
															id="postkrafaAmount"
															name="postkrafaAmount"
															placeholder="Upphæð (kr)"
														/>
													</FormikFieldWrapper>
												</Column>
												<Column tablet={1 / 2}>
													<FormikFieldWrapper
														name="postkrafaId"
														languageComponent="registerShipment">
														<StyledFormikField
															type="text"
															id="postkrafaId"
															name="postkrafaId"
															placeholder="Kennitala reikningseiganda"
														/>
													</FormikFieldWrapper>
												</Column>
												<Column tablet={1 / 3}>
													<FormikFieldWrapper
														name="postkrafaBank"
														languageComponent="registerShipment">
														<StyledFormikField
															type="text"
															id="postkrafaBank"
															name="postkrafaBank"
															placeholder="Banki"
														/>
													</FormikFieldWrapper>
												</Column>
												<Column tablet={1 / 3}>
													<FormikFieldWrapper
														name="postkrafaHb"
														languageComponent="registerShipment">
														<StyledFormikField
															type="text"
															id="postkrafaHb"
															name="postkrafaHb"
															placeholder="Höfuðbók"
														/>
													</FormikFieldWrapper>
												</Column>
												<Column tablet={1 / 3}>
													<FormikFieldWrapper
														name="postkrafaRkn"
														languageComponent="registerShipment">
														<StyledFormikField
															type="text"
															id="postkrafaRkn"
															name="postkrafaRkn"
															placeholder="Reikningsnúmer"
														/>
													</FormikFieldWrapper>
												</Column>
												<Column tablet={1}>
													<FormikFieldWrapper
														name="postkrafaTilvisun"
														languageComponent="registerShipment">
														<StyledFormikField
															type="text"
															id="postkrafaTilvisun"
															name="postkrafaTilvisun"
															placeholder="Tilvísun póstkröfu"
														/>
													</FormikFieldWrapper>
												</Column>
											</StyledFormikTest.FieldWrapper>
										</FormikCheckboxTile>
									</FormikCheckboxTileGroup>
								</FormikFieldWrapper>
							</Column>
						</StyledFormikTest.FieldWrapper>
						<StyledFormikTest.FieldWrapper>
							<Column>
								<FormikFieldWrapper
									name="senderForeignCitizenship"
									label="Sendandi?"
									languageComponent="registerShipment">
									<FormikCheckbox
										name="senderForeignCitizenship"
										id="senderForeignCitizenship"
										label="Sendandi er með erlent ríkisfang"
										setFieldValue={setFieldValue}
									/>
								</FormikFieldWrapper>
							</Column>
						</StyledFormikTest.FieldWrapper>
						<Button type="submit" primary>
							Submit
						</Button>
					</Form>
				)}
			</Formik>
		</StyledFormikTest.Wrapper>
	);
};

export default FormikTest;
